import "./Terms.module.css";
import PulseThreadEntry from "@/reusable_sections/Header";
import WarrantyTerms from "./sections/WarrantyTerms";
import Footer from "@/reusable_sections/Footer";
export default function TermsPage() {
  return <div>
      <PulseThreadEntry />
      <WarrantyTerms />
      <Footer />
    </div>;
}